/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';

/**
 * Internal dependencies
 */
import Preloader from 'components/preloader';
import NewPlanEstimate from 'modules/me/new-plan-estimate';
import Modal from 'components/modal';
import { TowerProvider, Box } from '@towersystems/towersystems-design-system';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';

/**
 * Style dependencies
 */
import './styles.scss';

// this was originally written as a dialog; make it look like a modal.. to be consistent with
// everything else
//
const ConfirmNewPlanAlert = ({ onClose, onSubmit, ...rest }) => {
	const [submitting, setSubmitting] = useState(false);
	return (
		<TowerProvider>
			<Modal close={!submitting && onClose} isVisible={true} header={false} className='confirm-new-plan-modal'>
				{submitting && <Preloader />}
				<Box
					padding='xxlarge'
					style={{ height: '100%' }}
					display='flex'
					flexDirection='column'
					justifyContent='spaceBetween'
				>
					<NewPlanEstimate {...rest} />
					<ButtonGroup alignItems='center' justifyContent='center'>
						<Button disabled={submitting} className='btn' onClick={onClose}>
							Cancel
						</Button>
						<Button
							disabled={submitting}
							primary
							onClick={() => {
								setSubmitting(true);
								return onSubmit()
									.then(() => onClose())
									.catch((error) => console.log(error))
									.finally(() => {
										setSubmitting(false);
									});
							}}
						>
							Confirm & Subscribe
						</Button>
					</ButtonGroup>
				</Box>
			</Modal>
		</TowerProvider>
	);
};

export default ConfirmNewPlanAlert;
